<template>
  <div class="input-wrapper">
    <div class="gray700">{{ title }}</div>
    <input
      type="text"
      :placeholder="placeholder"
      :value="model"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>
<script>
export default {
  props: ['title', 'placeholder', 'model'],
}
</script>
